import { Box } from '@factorialco/deprecated-design-system'
import { DataSchemaItemFragment, WorkingConditionItemFragment } from 'generated/resources/graphql'

import NumberField from 'modules/core/components/NumberField'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { WizardData } from '../types'
import { getStringFieldValue } from '../utils'
import WorkingConditionValueTooltip from './WorkingConditionValueTooltip'

interface Props {
  fieldName: keyof WizardData
  field: DataSchemaItemFragment
  data: WizardData
  onChangeField: (fieldName: string, value: string) => void
  getFieldError?: (fieldName: keyof WizardData) => string | undefined
  workingConditionItems?: WorkingConditionItemFragment[]
  workingConditionName?: string
}

export const IntegerField = ({
  fieldName,
  field,
  data,
  onChangeField,
  getFieldError,
  workingConditionItems,
  workingConditionName,
}: Props) => {
  if (field.format == 'percentage_in_cents') {
    return (
      <NumberField
        label={field.label}
        value={data[fieldName] ? +data[fieldName] : undefined}
        onChange={(value: number | null) =>
          onChangeField(fieldName, value !== null ? value.toString() : '')
        }
        placeholder={i18n.t(
          'add_employee_modal.contract_information_step.fields.percentage_in_cents.placeholder'
        )}
        step={1}
        min={1}
        max={100}
        indicator="%"
      />
    )
  }

  const isWorkingConditionField = field.fieldName === 'contracts_max_legal_yearly_hours'
  const getWorkingConditionValue = (name: string) => {
    return workingConditionItems?.find((item) => `contracts_${item.name}` === name)?.value
  }
  const maxLegalYearlyHoursValueFromWC = getWorkingConditionValue(field.fieldName)
  const convertCentsValue = (value: string) => {
    if (value === '') return undefined
    if (field.format != 'cents') return value

    return String(parseInt(value) * 100)
  }

  const convertCentsToUI = (value: string) => {
    if (field.format != 'cents') return value
    return String(parseInt(value) / 100)
  }

  return (
    <Box flexDirection="row" alignItems="flexEnd" gap="s8" position="relative">
      <TextField
        key={field.fieldName}
        label={field.label}
        value={convertCentsToUI(getStringFieldValue(fieldName, data))}
        onChange={(value) => onChangeField(fieldName, convertCentsValue(value) || '')}
        type="number"
        min={0}
        error={!!getFieldError ? getFieldError(fieldName) : undefined}
        mandatory={field.required}
      />
      {isWorkingConditionField && maxLegalYearlyHoursValueFromWC && (
        <Box position="absolute" style={{ right: '38px', top: '34px' }}>
          <WorkingConditionValueTooltip
            linked={data.contractsMaxLegalYearlyHours === maxLegalYearlyHoursValueFromWC}
            onClick={() => onChangeField(fieldName, maxLegalYearlyHoursValueFromWC || '')}
            workingConditionName={workingConditionName}
          />
        </Box>
      )}
    </Box>
  )
}
